// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"ee453203f1fcdde3","6831":"5b1a88eba3d2927e","8503":"ecab0dcb0e5ef997","9683":"f39b925ac8bcbc18"}[chunkId] + ".js";
};